import IBAConsoleLayout from "Layout/IBAConsoleLayout";
import Header from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Alert from "@amzn/awsui-components-react/polaris/alert";
import Box from "@amzn/awsui-components-react/polaris/box";
import Popover from "@amzn/awsui-components-react/polaris/popover";
import Icon from "@amzn/awsui-components-react/polaris/icon";
import Link from "@amzn/awsui-components-react/polaris/link";
import useQueryListReports from "Api/useQueryListReports";
import Loading from "components/Loading";
import ReportSelector from "./reportSelector";
import ReportTable from "./reportTable";
import DownloadFullReportButton from "./downloadFullReportButton";
import { createTimestampFromEpochSeconds } from "../../utils/formatUtils";
import { useState } from "react";

const AccountingMonitorPage = () => {
  const { isLoading, error, data: listReportsResponse } = useQueryListReports();
  const [selectedFolder, setSelectedFolder] = useState("");

  const selectedReport = listReportsResponse?.reportFolders.find((folder) => folder.folderName === selectedFolder);

  return (
    <IBAConsoleLayout>
      <SpaceBetween direction="vertical" size="l">
        <Header
          variant="h1"
          info={
            <Popover
              header="Accounting Monitor"
              triggerType="custom"
              content={
                <Link
                  href="https://w.amazon.com/bin/view/B2B/IBA/Services/IBAConsole/Design/AccountingMonitor"
                  external
                  externalIconAriaLabel="Opens in a new tab"
                >
                  View the Accounting Monitor error definitions
                </Link>
              }
            >
              <Link variant="info" ariaLabel="Information about the Accounting Monitor">
                <Icon name="status-info" />
              </Link>
            </Popover>
          }
        >
          Accounting Monitor Reports
        </Header>

        {error && <Alert type="error">{error}</Alert>}

        <Loading isLoading={isLoading} reason="Loading available reports...">
          {listReportsResponse && listReportsResponse.reportFolders.length === 0 && (
            <Alert type="info">No reports available yet.</Alert>
          )}
          {listReportsResponse && listReportsResponse.reportFolders.length > 0 && (
            <SpaceBetween direction="vertical" size="l">
              <ReportSelector
                folders={listReportsResponse.reportFolders}
                selectedFolder={selectedFolder}
                onSelect={setSelectedFolder}
              />
              {selectedReport && (
                <SpaceBetween direction="vertical" size="s">
                  <Box color="text-body-secondary">
                    Report generated on {createTimestampFromEpochSeconds(selectedReport.reportCreatedAt)}
                  </Box>
                  <DownloadFullReportButton folderName={selectedReport.folderName} />
                  <ReportTable reportKey={selectedReport.metadataKey} />
                </SpaceBetween>
              )}
            </SpaceBetween>
          )}
        </Loading>
      </SpaceBetween>
    </IBAConsoleLayout>
  );
};

export default AccountingMonitorPage;
